import { render, staticRenderFns } from "./ClockAdvancedStats.vue?vue&type=template&id=36da538d&scoped=true"
import script from "./ClockAdvancedStats.vue?vue&type=script&lang=js"
export * from "./ClockAdvancedStats.vue?vue&type=script&lang=js"
import style0 from "./ClockAdvancedStats.vue?vue&type=style&index=0&id=36da538d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da538d",
  null
  
)

export default component.exports